import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Icon, IconButton } from "@mui/material";
import track from "../../assets/images/isuzutrack.png";
import geelytrack from "../../assets/images/geelytrack.png";

import "./Trucks.css";

function TruckData({truck, changeOrder}) {
  
  const { data } = useSelector((state) => state.data);
  const [showDays, setShowDays] = useState(false);

  const ProgressBar = (props) => {
    const { bgcolor, completed } = props;
    const containerStyles = {
      dir: 'rtl',
      height: 3,
      width: '100%',
      backgroundColor: '#d5d6e6',
      borderRadius: 50,
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }
  
    return (
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <span style={labelStyles}></span>
        </div>
      </div>
    );
  };

  const newStartDate= new Date(truck.StartDate);
  const newEndDate=new Date(truck.EndDate);
  const one_day = 1000*60*60*24;
  const totalDays = Math.ceil((newEndDate.getTime()-newStartDate.getTime())/(one_day))
  const progress = truck.ProgressPercentage;//%

  return (
    <Box className={"truck-box" + (truck.Docnum === data?.id ? " truck-box-active" : "")} onClick= {(e) => changeOrder(truck.Docnum)} onMouseOver={(e) => setShowDays(true)} onMouseLeave={(e) => setShowDays(false)}>
      {(true || showDays) && truck.daysLeft && 
        <>
          <div className="delivery"><span className="lighter">{'צפי אספקה '}</span><span>{truck.daysLeft + ' ימים'}</span></div>
          <div className="triangle-down"></div> 
        </>
      }
      <div className="truck-box-flex">
      <div>
            {truck.brand&&
              <img className="mini-truck" alt={truck.brand} src={truck.brand && truck.brand === 'ISUZU' ? track : geelytrack}></img>
            }
      </div>
      <div className="truck-box-data">
        <div className="truck-box-up">
          <div className="truck-box-right">{truck.weight + ' טון'}</div>
          <div className="truck-box-left">{truck.Docnum}</div>
        </div>
        <div>{truck.DealType === "Leasing" ? (truck.boxType + ' (ליסינג)') : truck.orderType}</div>
      </div>
      </div>
      <ProgressBar bgcolor={'blue'} completed={progress} />
    </Box>
      
  );
}

export default TruckData;
